<template>
  <nav class="vertical-stepper">
    <div
      v-for="(step, index) in steps"
      :key="step.title"
      class="vertical-stepper__item"
      :class="itemDynamicClasses(index)"
    >
      <div class="vertical-stepper__line" />

      <a
        class="vertical-stepper__item-content"
        @click.prevent="emitStep(index)"
      >
        <div class="vertical-stepper__index">
          <i v-if="isStepDisabled(index)" class="el-icon-close" />
          <i v-else-if="isStepDone(index)" class="el-icon-check" />
          <span v-else>{{ index + 1 }}</span>
        </div>

        <span class="vertical-stepper__title">{{ step.title }}</span>
      </a>

      <div v-if="isLastStep(index)" class="vertical-stepper__line" />
    </div>
  </nav>
</template>

<script>
export default {
  name: 'VerticalStepper',

  props: {
    steps: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    currentStep: {
      // it can have any type
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    lastDoneStep: {
      // it can have any type
      required: true,
    },
  },

  computed: {
    lastDoneStepIndex() {
      return this.steps.findIndex(step => step.key === this.lastDoneStep);
    },
    currentStepIndex() {
      return this.steps.findIndex(step => step.key === this.currentStep);
    },
  },

  methods: {
    itemDynamicClasses(index) {
      return {
        'vertical-stepper__item--disabled': !this.isStepDisabled(index),
        'vertical-stepper__item--current': index === this.currentStepIndex,
        'vertical-stepper__item--done':
          !this.isStepDisabled(index) && index <= this.lastDoneStepIndex,
      };
    },
    isStepDisabled(index) {
      return this.steps[index]?.disabled;
    },
    isStepDone(index) {
      const isPassedStep =
        index <= this.lastDoneStepIndex && index !== this.currentStepIndex;
      return !this.isStepDisabled(index) && isPassedStep;
    },

    isLastStep(index) {
      return index === this.steps.length - 1;
    },

    emitStep(index) {
      if (this.isStepDisabled(index)) return;

      const step = this.steps[index];
      if (index <= this.lastDoneStepIndex) {
        this.$emit('step-click', step.key);
      }
    },
  },
};
</script>

<style lang="scss">
.vertical-stepper {
  $block: &;

  width: rem-calc(220px);

  &__item {
    cursor: default;
    color: #ddd;
  }

  &__item-content {
    display: flex;
    align-items: center;
    padding: 4px 0;
    color: inherit;
    cursor: inherit;

    &:hover {
      color: unset;
    }
  }

  &__line {
    border-left: 2px solid #ddd;

    height: 35px;
    margin: 0 15px;

    @include rtl() {
      border-left-width: 0;
      border-right: 2px solid #ddd;
    }
  }

  &__index {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-weight: 400;
    text-align: center;
    border: 2px solid #ddd;
    border-radius: 50%;
    margin-right: $global-margin;

    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
    }
  }

  &__item--done {
    cursor: pointer;
    color: $lb-color-primary;

    #{$block}__index {
      border-color: $lb-color-primary;
    }

    #{$block}__line {
      border-color: $lb-color-primary;
    }
  }

  &__item--current {
    cursor: default;
    color: #34495e;

    #{$block}__index {
      border-color: #34495e;
    }

    #{$block}__line {
      border-color: #34495e;
    }
  }
}

@include breakpoint(medium down) {
  .vertical-stepper {
    width: unset;

    &__title {
      display: none;
    }

    &__index {
      margin-left: 0;
    }
  }
}
</style>
